import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const SHORTCUTS = [
  { keys: "⌘ K", desc: "Kommandopalett" },
  { keys: "⌘ L", desc: "Åpne katalog (hovedbudsjett)" },
  { keys: "⌘ ⇧ L", desc: "Åpne katalog for siste tilvalg" },
  { keys: "⌘ S", desc: "Lagre tilbud" },
  { keys: "⌘ D", desc: "Dupliser linjen som har fokus" },
  { keys: "⌥ dra", desc: "Dupliser linje ved slipp (Chrome/Firefox)" },
  { keys: "⌘ B", desc: "Skjul/vis sidemeny" },
  { keys: "N", desc: "Nytt tilbud (på tilbudslisten)" },
  { keys: "↑ / ↓", desc: "Samme felt på linjen over / under" },
  { keys: "⌥ ↑ / ⌥ ↓", desc: "Flytt linjen som har fokus opp / ned" },
  { keys: "← / →", desc: "I enhetsvelger: forrige / neste enhet" },
  { keys: "t / d / s / f", desc: "Velg enhet (også i antall, sats og innkjøp)" },
  { keys: "o", desc: "Åpne overtidslinje (intern time/dag, uten å miste fokus)" },
  { keys: "Tab / Enter", desc: "På siste rad: legg til ny linje" },
  { keys: "Esc", desc: "Lukk celle uten å lagre" },
  { keys: "?", desc: "Vis denne hjelpen" },
] as const;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function OfferKeyboardHelpDialog({
  open,
  onOpenChange,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Tastatursnarveier</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 mt-2">
          {SHORTCUTS.map((s) => (
            <div key={s.keys} className="flex items-center justify-between gap-3 text-sm">
              <span className="text-muted-foreground flex-1">{s.desc}</span>
              <kbd className="px-2 py-0.5 text-xs font-mono bg-muted rounded border border-border whitespace-nowrap">
                {s.keys}
              </kbd>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
